import React from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'

const ForceTbiAndInvoice = ({ order, refetch }) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    if(confirm(formatMessage(messages.confirm))) {
      toastr.info(formatMessage(messages.info))

      const body = new FormData()
      body.append('orderid', order.uid)

      fetch(`/order/forceInvoiceOrder.json`, { method: 'POST', body }) 
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          toastr.success(formatMessage(messages.success))
        } else {
          toastr.error(formatMessage(messages.error, { errors: data.errors.join(', ') }))
        }
        refetch()
      })
      .catch((error) => toastr.error(error))
    }
  }

  return (
    <Menu.Item state="negative">
      {(props) => (
        <MenuButton {...props} onClick={onClick}>
          {formatMessage(messages.title)}
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default ForceTbiAndInvoice
